import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonicApp, Nav, Platform } from 'ionic-angular';
import { AuthenticationServiceProvider } from '../modules/core/services/authentication-service/authentication-service';
import { DataUpdateServiceProvider } from '../modules/core/services/data-update-service/data-update-service';
import { LifeCycleServiceProvider } from '../modules/core/services/life-cycle-service/life-cycle-service';
import { TextServiceProvider } from '../modules/core/services/text-service/text-service';

@Component({
  templateUrl: 'app.html',
})
export class MyApp implements OnInit, AfterViewInit {
  @ViewChild(Nav) nav: Nav;

  constructor(
    private alertController: AlertController,
    private ionicApp: IonicApp,
    private lifeCycleService: LifeCycleServiceProvider,
    private platform: Platform,
    private textService: TextServiceProvider,
    private authenticationService: AuthenticationServiceProvider,
    private dataUpdateService: DataUpdateServiceProvider,
  ) {}

  ngOnInit() {
    this.lifeCycleService.initializeEventListeners();

    this.platform.registerBackButtonAction(() => {
      this.handlePressedBackButton();
    });
  }

  ngAfterViewInit(): void {
    const refreshToken = window.location.search.split('code=')[1];
    if (refreshToken != null) {
      this.authenticationService
        .exchangeCodeForToken(refreshToken)
        .then(() => {
          this.dataUpdateService.loadInternalData();
        })
        .then(() => {
          this.nav.setRoot('LoadingPage', {}, { animate: true, direction: 'forward' });
        });
    }
  }

  private handlePressedBackButton() {
    let thereIsPreviousScreen = this.nav.length() > 1;
    let modal = this.ionicApp._modalPortal.getActive();
    let toast = this.ionicApp._toastPortal.getActive();
    let overlay = this.ionicApp._overlayPortal.getActive();
    let activeComponentId = this.nav.getActive().id;

    if (thereIsPreviousScreen) {
      this.nav.pop();
    } else if (modal || toast || overlay) {
      let toDismiss = modal || toast || overlay;
      toDismiss.dismiss();
    } else if (activeComponentId === 'MenuPage' || activeComponentId === 'LoginPage') {
      this.confirmApplicationClosing();
    } else {
      this.nav.setRoot('MenuPage', { root: 0 }, { animate: true });
    }
  }

  private confirmApplicationClosing() {
    let alert = this.alertController.create({
      title: this.textService.get('appEnd') || 'Zakończ',
      message: this.textService.get('appAreYouSure') || 'Czy na pewno chcesz zamknąć aplikację?',
      buttons: [
        {
          text: this.textService.get('appNo') || 'Nie',
          role: 'cancel',
        },
        {
          text: this.textService.get('appYes') || 'Tak',
          handler: () => this.platform.exitApp(),
        },
      ],
    });

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts